import CoreApi from '@/api/CoreApi';
import type { DevaugePalletizingStatus } from '@/models/DevaugePalletizingStatus';

export default async function loadDevaugePalletizingStatus(
  location: string,
): Promise<DevaugePalletizingStatus[]> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/variables/devauge-${location}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load palletizing statuses: ${error.message}`);
  }
}
